/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { TotoGame } from '../models/TotoGame';
import type { TotoGameCreate } from '../models/TotoGameCreate';
import type { TotoGamePatch } from '../models/TotoGamePatch';
import type { TotoGameSmall } from '../models/TotoGameSmall';
import type { TotoMatchday } from '../models/TotoMatchday';
import type { TotoPlayerSmall } from '../models/TotoPlayerSmall';
import type { TotoRankingEntry } from '../models/TotoRankingEntry';
import type { TotoSettingsPatch } from '../models/TotoSettingsPatch';
import type { TotoSettingsSmall } from '../models/TotoSettingsSmall';
import type { TotoTipEntry } from '../models/TotoTipEntry';
import type { TotoTipEntryPatch } from '../models/TotoTipEntryPatch';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class TotoGameService {
    /**
     * Get My Toto Games
     * @returns TotoGameSmall Successful Response
     * @throws ApiError
     */
    public static getMyTotoGames(): CancelablePromise<Array<TotoGameSmall>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/toto/toto_game/my',
        });
    }
    /**
     * Get Toto Game
     * @param totoGameId
     * @returns TotoGame Successful Response
     * @throws ApiError
     */
    public static getTotoGame(
        totoGameId: number,
    ): CancelablePromise<TotoGame> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/toto/toto_game/{toto_game_id}',
            path: {
                'toto_game_id': totoGameId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Patch Toto Game
     * @param totoGameId
     * @param requestBody
     * @returns TotoGame Successful Response
     * @throws ApiError
     */
    public static patchTotoGame(
        totoGameId: number,
        requestBody: TotoGamePatch,
    ): CancelablePromise<TotoGame> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/toto/toto_game/{toto_game_id}',
            path: {
                'toto_game_id': totoGameId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Delete Toto Game
     * @param totoGameId
     * @returns TotoGameSmall Successful Response
     * @throws ApiError
     */
    public static deleteTotoGame(
        totoGameId: number,
    ): CancelablePromise<Array<TotoGameSmall>> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/toto/toto_game/{toto_game_id}',
            path: {
                'toto_game_id': totoGameId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Create Toto Game
     * @param requestBody
     * @returns TotoGame Successful Response
     * @throws ApiError
     */
    public static createTotoGame(
        requestBody: TotoGameCreate,
    ): CancelablePromise<TotoGame> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/toto/toto_game',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Toto Game By Share Key
     * @param shareKey
     * @returns TotoGame Successful Response
     * @throws ApiError
     */
    public static getTotoGameByShareKey(
        shareKey: string,
    ): CancelablePromise<TotoGame> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/toto/toto_game/invite/{share_key}',
            path: {
                'share_key': shareKey,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Join Toto Game
     * @param totoGameId
     * @param playerName
     * @returns TotoGame Successful Response
     * @throws ApiError
     */
    public static joinTotoGame(
        totoGameId: number,
        playerName: string,
    ): CancelablePromise<TotoGame> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/toto/toto_game/join/{toto_game_id}',
            path: {
                'toto_game_id': totoGameId,
            },
            query: {
                'player_name': playerName,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Leave Toto Game
     * @param totoPlayerId
     * @returns TotoGameSmall Successful Response
     * @throws ApiError
     */
    public static leaveTotoGame(
        totoPlayerId: number,
    ): CancelablePromise<Array<TotoGameSmall>> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/toto/toto_game/leave/{toto_player_id}',
            path: {
                'toto_player_id': totoPlayerId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Kick Toto Player
     * @param totoPlayerId
     * @returns TotoPlayerSmall Successful Response
     * @throws ApiError
     */
    public static kickTotoPlayer(
        totoPlayerId: number,
    ): CancelablePromise<Array<TotoPlayerSmall>> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/toto/toto_game/kick/{toto_player_id}',
            path: {
                'toto_player_id': totoPlayerId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Un Kick Toto Player
     * @param totoPlayerId
     * @returns TotoPlayerSmall Successful Response
     * @throws ApiError
     */
    public static unKickTotoPlayer(
        totoPlayerId: number,
    ): CancelablePromise<Array<TotoPlayerSmall>> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/toto/toto_game/unkick/{toto_player_id}',
            path: {
                'toto_player_id': totoPlayerId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Toto Matchdays
     * @param totoGameId
     * @returns TotoMatchday Successful Response
     * @throws ApiError
     */
    public static getTotoMatchdays(
        totoGameId: number,
    ): CancelablePromise<Array<TotoMatchday>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/toto/toto_matchdays/{toto_game_id}',
            path: {
                'toto_game_id': totoGameId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Toto Tip Entries
     * @param totoGameId
     * @param matchday
     * @param totoPlayerId
     * @returns TotoTipEntry Successful Response
     * @throws ApiError
     */
    public static getTotoTipEntries(
        totoGameId: number,
        matchday: number,
        totoPlayerId: number,
    ): CancelablePromise<Array<TotoTipEntry>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/toto/toto_tip_entries',
            query: {
                'toto_game_id': totoGameId,
                'matchday': matchday,
                'toto_player_id': totoPlayerId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Tip On A Toto Entry
     * @param totoGameId
     * @param requestBody
     * @returns TotoTipEntry Successful Response
     * @throws ApiError
     */
    public static tipOnATotoEntry(
        totoGameId: number,
        requestBody: TotoTipEntryPatch,
    ): CancelablePromise<TotoTipEntry> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/toto/toto_tip_entry/{toto_game_id}',
            path: {
                'toto_game_id': totoGameId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Toto Ranking
     * @param totoGameId
     * @param matchDay
     * @param limit
     * @param offset
     * @returns TotoRankingEntry Successful Response
     * @throws ApiError
     */
    public static getTotoRanking(
        totoGameId: number,
        matchDay?: (number | null),
        limit: number = 10,
        offset?: number,
    ): CancelablePromise<Array<TotoRankingEntry>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/toto/toto_ranking/{toto_game_id}',
            path: {
                'toto_game_id': totoGameId,
            },
            query: {
                'match_day': matchDay,
                'limit': limit,
                'offset': offset,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Toto Ranking By Toto Player Id
     * @param totoGameId
     * @param totoPlayerId
     * @param matchDay
     * @param halfLimit
     * @param offset
     * @returns TotoRankingEntry Successful Response
     * @throws ApiError
     */
    public static getTotoRankingByTotoPlayerId(
        totoGameId: number,
        totoPlayerId: number,
        matchDay?: (number | null),
        halfLimit: number = 10,
        offset?: number,
    ): CancelablePromise<Array<TotoRankingEntry>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/toto/toto_ranking/{toto_game_id}/player/{toto_player_id}',
            path: {
                'toto_game_id': totoGameId,
                'toto_player_id': totoPlayerId,
            },
            query: {
                'match_day': matchDay,
                'half_limit': halfLimit,
                'offset': offset,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Toto Settings
     * @returns TotoSettingsSmall Successful Response
     * @throws ApiError
     */
    public static getTotoSettings(): CancelablePromise<TotoSettingsSmall> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/toto/toto_settings',
        });
    }
    /**
     * Get Toto Settings
     * @param requestBody
     * @returns TotoSettingsSmall Successful Response
     * @throws ApiError
     */
    public static patchTotoSettings(
        requestBody: TotoSettingsPatch,
    ): CancelablePromise<TotoSettingsSmall> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/toto/toto_settings',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Toto Game Ids With Missing Tips
     * @param withinHours
     * @returns number Successful Response
     * @throws ApiError
     */
    public static getTotoGameIdsWithMissingTips(
        withinHours?: any,
    ): CancelablePromise<Array<number>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/toto/missing_tips',
            query: {
                'within_hours': withinHours,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
}
